import React from 'react';

const OUTLOOK_CONFIG = {
  FAVORABLE: { label: 'FAVORABLE', colorClass: 'matchup-badge--favorable' },
  NEUTRAL:   { label: 'NEUTRAL',   colorClass: 'matchup-badge--neutral'   },
  TOUGH:     { label: 'TOUGH',     colorClass: 'matchup-badge--tough'      },
};

/**
 * Colored pill badge showing a player's upcoming-matchups outlook.
 * Greyed for Free-tier users.
 *
 * @param {Object}   props
 * @param {string}   props.outlook   - "FAVORABLE" | "NEUTRAL" | "TOUGH"
 * @param {boolean}  props.isPro     - Whether user has Pro subscription
 * @param {Function} props.onClick   - Called when badge is clicked
 */
export default function MatchupPreviewBadge({ outlook, isPro, onClick }) {
  if (!isPro) {
    return (
      <span
        className="matchup-badge matchup-badge--locked"
        title="Upgrade to Pro for matchup previews"
      >
        PRO
      </span>
    );
  }

  const config = OUTLOOK_CONFIG[outlook] || { label: outlook, colorClass: '' };

  return (
    <button
      className={`matchup-badge ${config.colorClass}`}
      onClick={onClick}
      aria-label={`Matchup outlook: ${config.label}`}
    >
      {config.label}
    </button>
  );
}
